@if (visible()) {
<button
    type="button"
    class="pylon-launcher"
    [data-testing]="'open-pylon-chat-bubble'"
    aria-label="Open support chat"
    title="Chat with us"
    (click)="open()"
>
    <svg
        class="pylon-launcher__icon"
        viewBox="0 0 24 24"
        width="26"
        height="26"
        aria-hidden="true"
        focusable="false"
    >
        <path
            fill="currentColor"
            d="M12 3c-4.97 0-9 3.58-9 8 0 2.52 1.32 4.77 3.4 6.24-.13 1.03-.6 2.02-1.32 2.79-.2.21-.06.56.23.58 1.6.08 3.16-.4 4.42-1.35.72.18 1.48.28 2.27.28 4.97 0 9-3.58 9-8s-4.03-8-9-8Z"
        />
    </svg>
</button>
}
